export default __webpack_public_path__ + "static/media/hotel-vector.daac0620.svg";